export const keySize = 58

export const rowOffset = keySize / 2
